import { partyRouteObject } from '@features/onboarding/routes';
import { transactionRouteObject } from '@features/transaction/routes';
import { FailedTransactionPage } from '@features/transaction/routes/lazy';
import { publicUserRouteObject, userProfileRouteObject } from '@features/user/routes';
import { AuthGuard } from '@guards/AuthGuard';
import { GuestGuard } from '@guards/GuestGuard';
import { OnboardingGuard } from '@guards/OnboardingGuard';
import WuDashboardLayout from '@layout/index';
import { NotFound } from '@routing/lazy';

export const wuComRoutes = [
  {
    path: '/test',
    element: <WuDashboardLayout />,
    children: [
      {
        path: '/test/failed-tr',
        element: <FailedTransactionPage />,
      },
    ],
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <WuDashboardLayout />
        </OnboardingGuard>
      </AuthGuard>
    ), // Add Home Layout
    children: [
      { ...transactionRouteObject },
      { ...userProfileRouteObject },
      { ...partyRouteObject },
    ],
  },
  {
    path: '/public',
    element: (
      <GuestGuard>
        <WuDashboardLayout />
      </GuestGuard>
    ), // Add Home Layout
    children: [{ ...publicUserRouteObject }],
  },
  { path: '*', element: <NotFound /> }, // Add 404 Page
];
